import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('generic_benefits_set', '/generic_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
